<template>
    <div>
      <StatusBasedCases :selectedBilledStatuses="statuses"></StatusBasedCases>
    </div>
  </template>
    
    <script>
  const StatusBasedCases = defineAsyncComponent(() =>
    import("@/components/cases/AllCases")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        StatusBasedCases,
    },
    data() {
    return {
      statuses: "Billed with Exception",
    };
  },
  };
  </script>
    